import { Autocomplete, Badge, Box, Card, Checkbox, CircularProgress, FormControl, FormControlLabel, FormHelperText, Grid, InputLabel, MenuItem, Select, Stack, TextField, Typography } from '@mui/material';
import MDButton from 'components/MDButton';
import CommonLayout from 'layouts/DashboardLayout';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import defaultImage from 'assets/images/placeholder-image.png';
import MDInput from 'components/MDInput';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { openSnackbar } from '../../../redux/slices/common';
import { uploadImage } from '../../../redux/slices/common';
import { validateStrainData } from 'validations/strain';
import { capitalizeText } from 'utilities/common';
import { createStrain, deleteStrain, getFlavoursList, getSingleStrain, updateStrain } from '../../../redux/slices/strain';
import { isEmptyObject } from 'utilities/common';
import { closeCustomModalDialog, openCustomModalDialog, setModalLoader } from '../../../redux/slices/modalSlice';
import CommonQuillEditor from 'common/editor';
import { slugRegex } from 'utilities/common';
import { strainPrompt } from 'prompt';
import { convertAndExtractMeta } from 'utilities/common';
import SmartToyIcon from '@mui/icons-material/SmartToy'; // AI robot icon
import { STILO } from 'utilities/constants';
import StiloAddEditStrain from './component/stiloUpdateForm';
import { getData } from 'utilities/common';
import AltImageSection from './component/ImageUpdate';
export default function AddStrainForm() {
  const { flavors, singleStrain = {}, loading = false } = useSelector(state => state.strain);
  const { infoEffectData = [], isUploading = false } = useSelector(state => state.common);
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");
  const { strainId } = useParams();
  const [formData, setFormData] = useState({
    strainName: '',
    strainCategory: '',
    metaTitle: '',
    metaDescription: '',
    title: 'test',
    description: '',
    infoEffects: [],
    isPopularStrain: false,
    isBestStrain: false,
    flavors: [],
    title2: '',
    status: true,
    image: {},
    strainHeading: ""
  });
  const [productSlugData, setProductSlugData] = useState("")
  const [isProductSlug, setIsProductSlugData] = useState(false)
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const adminsMode = getData('adminsMode')
  const isStilo = JSON.parse(adminsMode) === STILO
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    const { errors, isValid } = validateStrainData({ ...formData, isStilo });
    if (!isValid) {
      setErrors(errors);
      return;
    }
    setErrors({});
    let payload = { ...formData };
    if (isProductSlug) {
      payload.subStrainSlug = `${productSlugData}`;
    }
    else {
      delete payload.subStrainSlug;
    }
    if (strainId) {

      dispatch(updateStrain({ data: payload, strainId, id })).unwrap().then((res) => {
        showError(res?.message, 'success');
        navigate('/strains?orderFilter=strains');
      }).catch((err) => {
        showError(err?.response?.message, 'error');
      });
    } else {
      dispatch(createStrain(payload)).unwrap().then((res) => {
        showError(res?.message, 'success');
        navigate('/strains?orderFilter=strains');
      }).catch((error) => {
        showError(error?.message || 'Something went wrong', 'error');
      });
    }
  };

  const showError = (message, errortype) => {
    if (errortype === 'success') {
      dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }));
    }
    if (errortype === 'error') {
      dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }));
    }
  };

  const infoEffectArr = useMemo(() => {
    return infoEffectData?.find((effect => effect?.strainType === formData.strainCategory))?.infoEffects || [];
  }, [formData.strainCategory, infoEffectData]);


  const deleteHandler = (strainId) => {
    dispatch(setModalLoader(true));
    dispatch(deleteStrain(strainId)).unwrap().then((res) => {
      showError(res?.message, 'success');
      dispatch(closeCustomModalDialog());
      navigate('/strains?orderFilter=strains');
    }).catch((err) => {
      dispatch(setModalLoader(false));
      showError(err?.message, 'error');
    });
  };

  const onChangeCheckbox = (e, name) => {
    e.preventDefault();
    let updatedEffects = [...(formData?.infoEffects || [])];
    let alreadyExist = updatedEffects.findIndex(v => v === name);
    if (alreadyExist === -1) {
      updatedEffects.push(name);
    } else {
      updatedEffects.splice(alreadyExist, 1);
    }
    setFormData({ ...formData, infoEffects: updatedEffects });
  };

  const handleModalImage = (type, data, index) => {
    dispatch(openCustomModalDialog({
      modal: 'IMAGE_MODAL_SEO',
      modalData: {
        imageContent: type, data, index, fileMediaHandler
      }
    }))
  }

  const fileMediaHandler = (mediaData, imageContent, index) => {
  }

  const strainImageUploader = async (e) => {
    if (e.target.files.length) {
      const file = e.target.files[0];
      const body = new FormData();
      body.append('filePath', file);
      // res.fileUrl
      dispatch(uploadImage(body)).unwrap().then((res => {
        const data = {
          alt: "",
          title: file?.name,
          description: "",
          url: res.fileUrl

        }
        // handleModalImage('strain', data)
        setFormData({ ...formData, image: res.fileUrl });
      }));
    }
  };

  useEffect(() => {
    dispatch(getFlavoursList());
  }, []);
  useEffect(() => {
    if (!isEmptyObject(singleStrain)) {
      if (singleStrain?.subStrainSlug) {
        setProductSlugData(singleStrain?.subStrainSlug);
      }

      setFormData({ ...formData, ...singleStrain });
    }
  }, [singleStrain]);
  useEffect(() => {
    if (strainId) {
      dispatch(getSingleStrain(strainId));
    }
  }, [strainId]);

  const uploadThumbnailImage = {
    borderRadius: '20px',
    width: '160px',
    height: '160px',
    objectFit: 'cover',
    boxShadow: '0 0 1px rgb(0 0 0 / 20%)'
  };
  const badgeCircularProgressIcon = {
    backgroundColor: '#fff',
    borderRadius: 10,
    p: .5,
    mr: 14,
    mt: 14
  };
  const handleChangeSlug = (e) => {
    const value = e.target.value;
    setIsProductSlugData(true);
    setProductSlugData(slugRegex(value));
  };
  const [aiResponse, setAiResponse] = useState('');
  const [isPromptLoading, setPromptIsLoading] = useState(false)


  // const handleGenerate = useCallback(async () => {
  //   setPromptIsLoading(true);
  //   setFormData(prev => ({
  //     ...prev,
  //     description:'',
  //     metaTitle: '',
  //     metaDescription: ''
  //   }));

  //   try {
  //     const prompt = strainPrompt(formData?.strainName);

  //     const response = await openai.chat.completions.create({
  //       model: "gpt-4o-mini",
  //       messages: [{ role: "user", content: prompt }],
  //       stream: true,
  //     });

  //     let fullContent = '';
  //     let buffer = '';

  //     for await (const chunk of response) {
  //       const content = chunk.choices[0]?.delta?.content || '';
  //       buffer += content;
  //       fullContent += content;

  //       // Try extracting meta only if buffer ends with something meaningful (like new line or punctuation)
  //       if (/[.\n!?]$/.test(buffer)) {
  //         const result = convertAndExtractMeta(fullContent);
  //         if (result.metaTitle || result.metaDescription) {
  //           setFormData(prev => ({
  //             ...prev,
  //             description: `${result?.content}`,
  //             metaTitle: result?.metaTitle || prev.metaTitle,
  //             metaDescription: `${result?.metaDescription}`
  //           }));
  //         }

  //         // Reset buffer to avoid re-parsing same data
  //         buffer = '';
  //       }
  //     }

  //     // Final cleanup — in case last chunk didn’t end with punctuation
  //     const finalResult = convertAndExtractMeta(fullContent);
  //     setFormData(prev => ({
  //       ...prev,
  //       description: `${finalResult?.content}`,
  //       metaTitle: finalResult?.metaTitle || prev.metaTitle,
  //       metaDescription: `${finalResult?.metaDescription}`
  //     }));
  //   } catch (error) {
  //   } finally {
  //     setPromptIsLoading(false);
  //   }
  // }, [formData?.strainName]);

  const handleGenerate = useCallback(async () => {
    setPromptIsLoading(true);
    setFormData(prev => ({
      ...prev,
      description: '',
      metaTitle: '',
      metaDescription: ''
    }));

    try {
      const prompt = strainPrompt(formData?.strainName);
      const payload = { prompt: prompt };
      const res = await fetch(`${process.env.REACT_APP_STILO_API_BASE_URL}/api/v1/generate/description`, {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_API_AUTH_KEY
        },
      });

      const reader = res.body.getReader();
      const decoder = new TextDecoder("utf-8");

      let fullContent = "";

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value, { stream: true });
        fullContent += chunk;

        // Optional: real-time update

        const finalResult = convertAndExtractMeta(fullContent);
        setFormData((prev) => ({
          ...prev,
          description: finalResult.content,
          metaTitle: finalResult.metaTitle || prev.metaTitle,
          metaDescription: finalResult.metaDescription,
        }));
      }
      const finalResult = convertAndExtractMeta(fullContent);
      setFormData((prev) => ({
        ...prev,
        description: finalResult.content,
        metaTitle: finalResult.metaTitle || prev.metaTitle,
        metaDescription: finalResult.metaDescription,
      }));

    } catch (error) {
    } finally {
      setPromptIsLoading(false);
    }
  }, [formData?.strainName]);


  return (
    <Box p={{ xs: 2, sm: 3, lg: 4 }}>
      <Card sx={{ p: { xs: 2, md: 3 }, borderRadius: 2.5, boxShadow: 'none' }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ sm: 'center' }} justifyContent='space-between' gap={2} mb={2}>
          {isStilo ? <Typography variant='h4' fontWeight='semibold' color='secondary'>{strainId ? `Update Strain: ${singleStrain?.strainName}` : "Add New Strain"} </Typography>
            : <Typography variant='h4' fontWeight='semibold' color='secondary'>{strainId ? "Update" : "Add"} Strain</Typography>}
          <Box display='flex' alignItems='center' gap={1.25}>
            <Typography variant='h5' fontWeight='semibold' color='secondary'>Status</Typography>
            <Stack direction='row' alignItems='center' gap={.75} lineHeight={1} p={.75} borderRadius={2} bgcolor='#F2F3F7'>
              <MDButton
                sx={{ minWidth: '92px', borderRadius: 1.75, minHeight: '28px', p: .25, fontWeight: 500 }}
                type='button'
                variant={formData?.status ? 'contained' : 'text'}
                color={formData?.status ? 'success' : 'dark'}
                size='small'
                onClick={() => setFormData({ ...formData, status: true })}
              >
                Active
              </MDButton>
              <MDButton
                sx={{ minWidth: '92px', borderRadius: 1.75, minHeight: '28px', p: .25, fontWeight: 500 }}
                type='button'
                variant={!formData?.status ? 'contained' : 'text'}
                color={!formData?.status ? 'error' : 'dark'}
                size='small'
                onClick={() => setFormData({ ...formData, status: false })}
              >
                Inactive
              </MDButton>
            </Stack>
          </Box>
        </Stack>

        {!isStilo ?
          <>
            <Typography variant='body2' fontWeight='semibold' mb={1}>Strain Image*</Typography>
            <Stack direction='row' alignItems='center' flexWrap='wrap' gap={1.25} mb={4.5}>
              <Badge
                overlap='circular'
                anchorOrigin={{ vertical: 'top', horizontal: 'right', }}
                badgeContent={
                  isUploading ? <CircularProgress size={32} color='primary' sx={badgeCircularProgressIcon} /> : ''
                }
              >
                <img style={uploadThumbnailImage} src={formData?.image || defaultImage} alt='' />
              </Badge>

              <label htmlFor='image-input'>
                <MDButton
                  sx={{ minWidth: '180px' }}
                  type='button'
                  variant='outlined'
                  color='secondary'
                  component='span'
                  disabled={isUploading}
                >
                  {
                    formData?.image ? 'Change Image' : 'Add Image'
                  }
                </MDButton>
              </label>

              <MDInput
                id='image-input'
                type='file'
                name='image'
                onChange={strainImageUploader}
                fullWidth
                disabled={isUploading}
                style={{ display: 'none' }}
              />
              {Boolean(errors?.image) && <FormHelperText sx={{ width: '100%', ml: 0, mt: -.5 }} error>{errors?.image}</FormHelperText>}
            </Stack>
          </>

          :
          <>
            <AltImageSection errors={errors} formData={formData} setFormData={setFormData} />
          </>
        }

        <Typography variant='body2' fontWeight='medium' color="#2E2E3A" mb={1}>Strain Info</Typography>
        {isStilo ?
          <StiloAddEditStrain
            formData={formData}
            setFormData={setFormData}
            handleInputChange={handleInputChange}
            errors={errors}
            infoEffectData={infoEffectData}
            strainId={strainId}
            productSlugData={productSlugData}
            handleChangeSlug={handleChangeSlug}
            handleGenerate={handleGenerate}
            isPromptLoading={isPromptLoading}
            infoEffectArr={infoEffectArr}
            flavors={flavors}
            onChangeCheckbox={onChangeCheckbox}
          />
          :
          <Grid container spacing={2.5}>
            <Grid item xs={12} sm={6} lg={3}>
              <TextField
                label='Strain Name*'
                value={formData.strainName}
                fullWidth
                variant='outlined'
                onChange={handleInputChange}
                name='strainName'
                error={Boolean(errors?.strainName)}
                helperText={errors?.strainName}
              />

            </Grid>
            <Grid item xs={12} sm={6} lg={3}>

              <TextField
                label='Strain Heading*'
                value={formData.strainHeading}
                fullWidth
                variant='outlined'
                onChange={handleInputChange}
                name='strainHeading'
                error={Boolean(errors?.strainHeading)}
                helperText={errors?.strainHeading}
              />
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
              <FormControl fullWidth>
                <InputLabel>Strain Category*</InputLabel>
                <Select
                  className='form-select'
                  error={Boolean(errors?.strainCategory)}
                  onChange={handleInputChange} label='Strain Category*' name='strainCategory' value={formData.strainCategory}>
                  {
                    infoEffectData?.map((infoStrain => {
                      return <MenuItem key={infoStrain.strainType} value={infoStrain.strainType}>{infoStrain?.strainType}</MenuItem>;
                    }))
                  }

                </Select>
                {Boolean(errors?.strainCategory) && <FormHelperText error>{errors?.strainCategory}</FormHelperText>}
              </FormControl>
            </Grid>
            {
              strainId && <Grid item xs={12} md={6} lg={3}>
                <TextField
                  className="form-input"
                  fullWidth
                  label="Strain Slug"
                  name="subStrainSlug"
                  value={productSlugData}
                  onChange={handleChangeSlug}
                />
              </Grid>
            }
            <Grid item xs={12}>
              <Typography variant='body2' fontWeight='medium' color='#2E2E3A' mt={1} mb={1}>Title*</Typography>
              <CommonQuillEditor
                value={formData?.title || ''}
                onChange={(value) => setFormData({ ...formData, title: value })}
              />
              {Boolean(errors?.title) && <FormHelperText error>{errors?.title}</FormHelperText>}
            </Grid>
            <Grid item xs={12}>
              <Box display="flex" alignItems="center" gap={2}>
                <Typography variant="body2" fontWeight="medium" color="#2E2E3A">
                  Generate Meta Content
                </Typography>

                <MDButton
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={handleGenerate}
                  disabled={isPromptLoading || !formData?.strainName}
                  startIcon={!isPromptLoading && <SmartToyIcon />} // Show icon only when not loading
                >
                  {isPromptLoading ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    'Generate'
                  )}
                </MDButton>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Typography variant='body2' fontWeight='medium' color='#2E2E3A' mt={1} mb={1}>Description*</Typography>
              <CommonQuillEditor
                value={formData?.description || ''}
                onChange={(value) => setFormData({ ...formData, description: value })}
              />
              {Boolean(errors?.description) && <FormHelperText error>{errors?.description}</FormHelperText>}
            </Grid>

            <Grid item xs={12}>
              <Typography variant='body2' fontWeight='medium' color='#2E2E3A' mt={1} mb={1}>Meta Title*</Typography>
              <CommonQuillEditor
                value={formData?.metaTitle || ''}
                onChange={(value) => setFormData({ ...formData, metaTitle: value })}
              />
              {Boolean(errors?.metaTitle) && <FormHelperText error>{errors?.metaTitle}</FormHelperText>}
            </Grid>
            <Grid item xs={12}>
              <Box >
                <Typography variant='body2' fontWeight='medium' color='#2E2E3A' mt={1} mb={1}>Meta Description*</Typography>
                <CommonQuillEditor
                  value={formData?.metaDescription || ''}
                  onChange={(value) => setFormData({ ...formData, metaDescription: value })}
                />
                {Boolean(errors?.metaDescription) && <FormHelperText error>{errors?.metaDescription}</FormHelperText>}
              </Box>
            </Grid>

            <Grid item xs={12}>
              {
                infoEffectArr?.length ? <>
                  <Stack direction='row' flexWrap='wrap' gap={2} sx={{ backgroundColor: '#F1F1F1' }} px={2.5} py={2} borderRadius={4}>
                    {
                      infoEffectArr?.map((item, index) => {
                        const { title } = item;
                        const capatlizedTitle = capitalizeText(title);
                        let value = formData?.infoEffects?.includes(title);
                        return <FormControlLabel
                          key={index}
                          className='form-chip-checkbox'
                          control={<Checkbox checked={value} />}
                          label={capatlizedTitle}
                          onChange={(e) => onChangeCheckbox(e, title)}
                        />;
                      })
                    }
                  </Stack>
                </>
                  :
                  null
              }
            </Grid>
            <Grid item xs={12}>
              <Stack direction='row' flexWrap='wrap' gap={2}>
                <FormControlLabel
                  className='form-chip-checkbox chip-success'
                  value='Best Strain'
                  control={<Checkbox />}
                  label='Best Strain'
                  onChange={(e) => setFormData({ ...formData, isBestStrain: e.target.checked })}
                />
                <FormControlLabel
                  className='form-chip-checkbox chip-error'
                  value='Popular Strain'
                  control={<Checkbox />}
                  label='Popular Strain'
                  onChange={(e) => setFormData({ ...formData, isPopularStrain: e.target.checked })}
                />
              </Stack>
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                multiple
                id='tags-outlined'
                options={flavors || []}
                getOptionLabel={(option) => option.flavorType}
                filterSelectedOptions
                onChange={(val, selectedOption) => {
                  setFormData({ ...formData, flavors: selectedOption });
                }}
                value={formData?.flavors}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={Boolean(errors?.flavors)}
                    helperText={errors?.flavors}
                    label='Flavours'
                    placeholder='Categories'
                  />
                )}
              />
              {Boolean(errors?.flavors) && <FormHelperText error>{errors?.flavors}</FormHelperText>}
            </Grid>
            <Grid item xs={12}>
              <Typography variant='body2' fontWeight='medium' color='#2E2E3A' mt={1} mb={1}>Title2</Typography>
              <CommonQuillEditor
                value={formData?.title2 || ''}
                onChange={(value) => setFormData({ ...formData, title2: value })}
              />
              {Boolean(errors?.title2) && <FormHelperText error>{errors?.title2}</FormHelperText>}
            </Grid>
          </Grid>
        }

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} mt={2}>
          <MDButton
            sx={{ minWidth: '160px' }}
            type='button'
            variant='contained'
            color='primary'
            disabled={isUploading}
            onClick={handleSubmit}
            loading={loading}
          >
            {strainId ? 'Update' : ' Save'}
          </MDButton>
          {
            strainId && <MDButton
              sx={{ minWidth: '160px', backgroundColor: '#F1F1F1', color: '#FD4438' }}
              type='button'
              variant='contained'
              color='error'
              onClick={() => dispatch(openCustomModalDialog({ modalData: { deleteHandler, deleteId: id }, modal: 'DELETE_MODAL' }))}
            >
              Delete
            </MDButton>
          }
          <MDButton
            sx={{ minWidth: '160px' }}
            type='button'
            variant='outlined'
            color='dark'
            onClick={() => navigate('/strains')}
          >
            Cancel
          </MDButton>
        </Stack>
      </Card>
    </Box>
  );
}